<template>
  <div>
    <a class='ambia-item-title-link' @click='toggleOverlay'>{{ title }}</a>

    <v-overlay :value='videoOverlay' :opacity='0.75' z-index='120' @click='videoOverlay = false'>
      <v-btn
        icon
        class='overlay-experience-close'
        @click='toggleOverlay'
      >
        <v-icon>{{ mdiClose }}</v-icon>
      </v-btn>
      <span class='overlay-experience-title text-wrap'>{{ title }}</span>
      <div v-if='imePlayer'>
        <iframe id='player'
                :src='src'
                allow='xr-spatial-tracking,gyroscope,accelerometer,fullscreen'
                height='100%'
                width='100%'
                frameborder='0'
                class='overlay-experience'
                style=''
                @load='imePlayerLoaded'
        />
      </div>
      <div v-else>
        <video
          id='video'
          oncontextmenu='return false;'
          preload='auto'
          controls
          controlsList='nodownload'
          :src='src'
          class='overlay-experience'
        />
      </div>
    </v-overlay>
  </div>
</template>

<script>
import { mdiClose } from '@mdi/js'
const imePlayerEmbed = '//unpkg.com/imeplayer-embed@latest/dist/embed.js'

  export default {
    name: 'OverlayVideo',
    props: {
      src: {
        type: String,
        default: null
      },
      title: {
        type: String,
        default: null
      },
      imePlayer: {
        type: Boolean,
        default: true
      },
    },
    data () {
      return {
        videoOverlay: false,
        mdiClose
      }
    },

    methods: {
      toggleOverlay() {
        this.videoOverlay = !this.videoOverlay

        if (this.videoOverlay) {
          document.documentElement.style.overflowY = 'hidden'
        } else {
          document.documentElement.style.overflowY = 'scroll'
        }
      },

      isIOS() {
        return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
      },

      imePlayerLoaded () {
        if (this.isIOS()) {
          var scriptTag = document.createElement('script')
          scriptTag.id = 'imeplayer-embed'
          scriptTag.type = 'text/javascript'
          scriptTag.src = `${imePlayerEmbed}`
          document.getElementsByTagName('head')[0].appendChild(scriptTag)
        }
      }
    }
  }
</script>

